exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2cVdqHhIXbxWGkKIhxtmkY{color:\"[theme:neutralPrimary, default:#333333]\";min-height:48px}html[dir] ._2cVdqHhIXbxWGkKIhxtmkY{-webkit-box-shadow:0 17px 0 -16px \"[theme:neutralLight, default:#eaeaea]\";box-shadow:0 17px 0 -16px \"[theme:neutralLight, default:#eaeaea]\"}html[dir] ._2cVdqHhIXbxWGkKIhxtmkY._2Uhvm72oOLhNYUJRgOhS_6{-webkit-box-shadow:0 -17px 0 -16px \"[theme:themePrimary, default:#0078D4]\";box-shadow:0 -17px 0 -16px \"[theme:themePrimary, default:#0078D4]\"}", ""]);

// exports
exports.locals = {
	"placeholderItem": "_2cVdqHhIXbxWGkKIhxtmkY",
	"topBorderDragOver": "_2Uhvm72oOLhNYUJRgOhS_6"
};